// import React from "react";
import { Controller } from "react-hook-form";
import { RadioGroup } from "@mui/material";
import Typography from "../../typography/typography";
import { memo } from "react";

const FormSwitcher = memo(({
  children,
  isFormSwitcher,
  control,
  fieldArrayName,
  formSwitcherName,
  label,
  resetForm,
}: any) => {
  if (isFormSwitcher) {
    return (
      <Controller
        control={control}
        name={`${fieldArrayName}.${formSwitcherName}`}
        render={({ field }) => (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "24px",
            }}
          >
            {label ? (
              <Typography
                type="s5"
                style={{ fontWeight: 500 }}
                color={"theme.secondary.900"}
              >
                {label}
              </Typography>
            ) : null}
            <RadioGroup
              value={field.value}
              onChange={(e) => {
                resetForm(e.target.value)
                field.onChange(e.target.value)
              }}
              row={true}
            >
              {children}
            </RadioGroup>
          </div>
        )}
      />
    );
  }
  return null;
});

export { FormSwitcher };
export default FormSwitcher;
